/* This file is autogenerated, see readme.md for instructions */
import ChatAddSvgIcon from '@bloomreach/banana-theme/icons/chat-add.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ChatAddIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ChatAddSvgIcon />
    </Icon>
  );
});

ChatAddIcon.displayName = 'ChatAddIcon';

export default ChatAddIcon;
